import { render, staticRenderFns } from "./carriers-e-app-platforms.vue?vue&type=template&id=0a300aa8&scoped=true&"
import script from "./carriers-e-app-platforms.vue?vue&type=script&lang=js&"
export * from "./carriers-e-app-platforms.vue?vue&type=script&lang=js&"
import style0 from "./carriers-e-app-platforms.vue?vue&type=style&index=0&id=0a300aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a300aa8",
  null
  
)

export default component.exports